import { Injectable, NgModule, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Configuracion, FraseDia } from '../models/Util';
import { DateService } from '../shared/date.service';
import { global } from '../shared/global';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  signalTasks = signal<any>({});

  private GET_CONFIG_PARAMETER_URL = environment.apiUrl + "u/cf/"
  private GET_PARTICIPACION_USUARIO_DOCUMENTO_URL = environment.apiUrl + "u/pd/"
  private GET_FRASE_DIA = environment.apiUrl + "u/fd"

  constructor(
    private httpClient: HttpClient,
    private dateService: DateService
  ) { }

  getFraseDia(): Observable<FraseDia> {
    return this.httpClient.get<FraseDia>(this.GET_FRASE_DIA)
  }

  getConfigurationParameter(id: number): Observable<Configuracion> {
    return this.httpClient.get<Configuracion>(this.GET_CONFIG_PARAMETER_URL + id)
  }

  getFechaSugerida(fecha: Date): Observable<any> {
    var tmpFecha = this.dateService.sendFormat(fecha);
    return this.httpClient.get<String>(environment.apiUrl +"u/fs/" + tmpFecha, {responseType: 'text' as 'json'})
  }

  getResumenTareas(): Observable<any>{
    return this.httpClient.get<any>(environment.apiUrl+"not/c").pipe(
      tap ((value:any)=> this.signalTasks.set(value))
    )
  }

  getNumeroTareasUsuario(id: number): Observable<any>{
    return this.httpClient.get<any>(environment.apiUrl+"not/cu/"+id)
  }

  callTasks(){
    this.httpClient.get<any>(environment.apiUrl+"not/c").subscribe({
          next:(value: any) => {
            global.tareas = value;
            this.signalTasks.set(value);
          },
    })
  }

  getParticipacionUsuarioDocumento(id: number): Observable<string> {
    return this.httpClient.get(this.GET_PARTICIPACION_USUARIO_DOCUMENTO_URL + id, {
      responseType: 'text',
    });
  }
}
